import AbstractModule from './AbstractModule';

export default class extends AbstractModule {
    constructor(options) {
        super(options);

        this.$dom = {};

        this.init();
    }

    /**
     * Initialiation.
     *
     * @return {void}
     */
    init() {
        // element DOM
        this.$dom.lists = this.$el.find('.js-contact-list');
        this.$dom.tabs = this.$el.find('.js-contact-tab');

        this.initEvents();
    }

    /**
     * Initialiation des événements.
     *
     * @return {void}
     */
    initEvents() {
        // clique sur les tabs
        this.$el.on('click.Contact', '.js-contact-tab', (e) => {
            this.onClickTabsItem(e);
        });
    }

    /**
     * Événement lors d'un clique sur un
     * tab présent dans le header.
     *
     * @param {event}  événement lors du clique
     * @return {void}
     */
    onClickTabsItem(event) {
        // on vérifie que l'élément ne soit pas déjà actif
        if ($(event.target).hasClass('is-active')) return;

        // supprimer l'état `is-active` sur les autres éléments
        this.$dom.tabs.removeClass('is-active');
        // this.$dom.tabs.find('.js-contact-tab-content').animate({ height: '0px' }, 1000);
        //this.$dom.tabs.find('.js-contact-tab-content').addClass('u-hidden');

        // activer l'élément
        $(event.target).addClass('is-active');
        // $(event.target).find('.js-contact-tab-content').animate({ height: '100%' }, 1);
        // $(event.target).find('.js-contact-tab-content').removeClass('u-hidden');

        // afficher la bonne catégorie
        const id = $(event.target).data('tab-id');
        const contents = this.$document.find('.js-contact-list');
        for (let i = 0; i < contents.length; i += 1) {
            if (contents.eq(i).data('content-id') === id) {
                setTimeout(() => {
                    contents.eq(i).removeClass('u-hidden');
                    setTimeout(() => {
                        contents.eq(i).addClass('is-active');
                    }, 50);
                }, 1000);
            } else {
                contents.eq(i).removeClass('is-active');
                setTimeout(() => {
                    contents.eq(i).addClass('u-hidden');
                }, 1000);
            }
        }
    }

    /**
     * Déstructeur.
     *
     * @return {void}
     */
    destroy() {
        this.$el.off('.Contact');

        this.$dom = {};
    }
}
